<template>
  <v-dialog scrollable max-width="800px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn v-on="on" @click="iniciar"> {{ titulo }}</v-btn>
      </div>
    </template>

    <v-card>
      <v-card-title> Buscador de obras </v-card-title>
      <v-card-text>
        <v-text-field
          ref="inputTema"
          setfocus
          type="text"
          v-model="nombreTema"
          @keyup.enter="buscar"
          label="nombre tema"
        />
        <v-text-field
          ref="inputAutor"
          type="text"
          v-model="nombreAutor"
          @keyup.enter="buscar"
          label="nombre autor (opcional)"
        />
        <v-text-field
          type="number"
          v-model="codWorkSq"
          @keyup.enter="buscar"
          label="codigo sgs"
        />

        {{ mensaje }}
        <v-data-table :headers="headers" :items="obras" v-if="obras.length > 0">
          <template v-slot:[`item.action`]="props">
            <v-btn small @click="seleccionar(props.item)">Seleccionar </v-btn>
          </template>
        </v-data-table>
        <span class="red--text">{{ errorMessage }}</span>

        <v-card-actions>
          <v-btn class="btn btn-primary" @click="showDialog = false">
            VOLVER
          </v-btn>
          <v-btn @click="buscar">Buscar</v-btn>
          <v-btn @click="agregarONI">Agregar como ONI</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  props: {
    nombreAutorAnterior: { type: String },
    titulo: { type: String, default: "AGREGAR OBRA" },
  },

  data() {
    return {
      nombreTema: "",
      nombreAutor: "",
      codWorkSq: "",
      errorMessage: "",
      temas: [],
      obras: [],
      mensaje: "",
      headers: [
        { text: "CodigoSGS", value: "codWorkSq" },
        { text: "Nombre", value: "title" },
        { text: "Autores", value: "autores" },
        { text: "Seleccionar", value: "action" },
      ],
      showDialog: false,
    };
  },

  mounted() {
    this.nombreAutor =
      this.nombreAutorAnterior != null ? this.nombreAutorAnterior : "";
  },

  methods: {
    iniciar() {
      this.errorMessage = "";
      this.nombreTema = "";
    },
    buscar() {

      
      this.errorMessage = "";
      this.mensaje = "buscando temas . . .";
      this.obras = [];

      let params;

      if (this.nombreTema || this.nombreAutor) {
        params = {
          nombreObra:
            this.nombreTema.trim().length == 0
              ? "%"
              : this.nombreTema.trim().toUpperCase() + "%",
          nombreAutor: `${
            this.nombreTema.trim().length > 0 ? "%" : ""
          }${this.nombreAutor.trim().toUpperCase().replace(" ", "%")}%`
        }
      }


      if (this.codWorkSq > 0) {
        params = {
          codWorkSq: this.codWorkSq
        }
      }

      if (params) {

        axios
          .get("/sgs/obras", { params })
          .then((response) => {
            this.obras = response.data;
            this.mensaje = "";
            console.log(response.data);
            this.loading = false;
            if (this.obras.length == 0) {
              this.errorMessage = "No se encontraron coincidencias";
            }
          })

          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.errorMessage = err.response.data;
            } else {
              this.errorMessage = "Error";
            }
            this.loading = false;
          });
      }
    },
    seleccionar(item) {
      this.$emit("seleccion", {
        id: item.codWorkSq,
        nombre: item.title,
        autores: item.autores,
      });
      this.obras = [];
      this.showDialog = false;
      this.codWorkSq = null;
    },
    agregarONI() {
      if (this.nombreTema.trim() == "") {
        this.errorMessage = "ingrese el nombre del tema";
        return;
      }
      this.$emit("seleccion", {
        id: null,
        nombre: this.nombreTema,
        autores: this.nombreAutor,
      });
      this.obras = [];
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.2s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.divScroll {
  margin: 4px, 4px;
  padding: 4px;
  /* background-color: green;  */
  /* width: 500px;  */
  height: 200px;
  overflow-x: hidden;
  overflow-x: auto;
  text-align: justify;
}
</style>
